import React, { useContext } from "react";
import { circledTick } from "../assets/icons";
import mobile from "../assets/mobile.png";
import { mobileFeatures } from "../utils/static";
import { AppContext } from "../context/context";

function Mobile() {
  const { setState } = useContext(AppContext);

  return (
    <div className="w-full h-fit lg:mt-16 px-8 smd:px-12 md:px-16 flex flex-col items-center mb-8 lg:mb-32">
      <div className="max-w-[1350px] h-fit flex flex-col lg:flex-row gap-8">
        <div className="max-w-[600px] lg:w-1/2 h-full flex flex-col gap-4">
          <h6 className="text-[22px] text-center md:text-left smd:text-[32px] md:text-[38px] xxl:text-[48px] font-bold leading-tight">
            Discover The Mobile Version of Our Software
          </h6>
          {/* <h6 className="text-center lg:text-left text-[22px] lg:text-[34px] font-bold leading-tight"></h6> */}

          <p className="text-center lg:text-left text-sm smd:text-base xxl:text-base text-gray-500">
            Seamless Performance, Any Device, Every Feature. Unleash
            productivity anywhere, anytime. Our mobile app mirrors every feature
            of the web app, empowering you with seamless access to workforce
            management, HR processes, leave management, and scheduling on the
            go.
          </p>

          <div className="flex flex-col gap-2">
            {mobileFeatures.map((feature, index) => (
              <p
                key={index}
                className="flex items-center whitespace-nowrap truncate gap-2"
              >
                <span className="w-4 text-green-400 pt-0.5">{circledTick}</span>
                {feature}
              </p>
            ))}
          </div>
        </div>

        <div className="w-full lg:w-1/2 h-full flex items-center justify-center">
          <img
            src={mobile}
            alt="mobile"
            className="w-[250px] smd:w-[320px] md:w-[350px] lg:w-[460px] xl:w-[500px] xxl:w-[540px] lg:mt-[-30px]"
            onLoad={() => {
              setState((ps) => ({ ...ps, loadedImages: ps.loadedImages + 1 }));
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Mobile;
